<script>
    import RenderMark from '@components/Templates/Serializer/RenderMark'
    export let marks, text
</script>

<span>
    {#if marks}
        <RenderMark {marks} {text} index={0} />
    {:elseif text}
        {text}
    {/if}
</span>

<style>
    span {
        white-space: pre-line;
        word-break: break-word;
    }
</style>
  